import { render, staticRenderFns } from "./OdontogramaMenuLateralDireito.vue?vue&type=template&id=03ed3e98&scoped=true"
import script from "./OdontogramaMenuLateralDireito.vue?vue&type=script&lang=js"
export * from "./OdontogramaMenuLateralDireito.vue?vue&type=script&lang=js"
import style0 from "./OdontogramaMenuLateralDireito.vue?vue&type=style&index=0&id=03ed3e98&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ed3e98",
  null
  
)

export default component.exports